<form [formGroup]="formGroup" class="d-flex flex-column edit-page">
  <div class="d-flex flex-row justify-content-between">
    <div class="d-flex flex-column">
      <span class="title">{{'memberPage.editPage.editProfile'|translate}}</span>
      <span class="required-fields">*{{'memberPage.editPage.required' |translate}}</span>
    </div>
    <mat-icon class="cursor-pointer" (click)="emitClose()">close</mat-icon>
  </div>
  <div class="d-flex flex-column">
    <div class="section">
      <span class="section-title">{{'memberPage.editPage.personalInformation' |translate}}</span>
      <app-input-field [control]="formGroup.controls.firstName"
                       class="field-container"
                       [label]="'createUser.firstName'|translate">
        <input name="name"
               formControlName="firstName"
               class="input">
      </app-input-field>
      <app-input-field [control]="formGroup.controls.lastName"
                       class="field-container"
                       [label]="'createUser.lastName'|translate">
        <input name="name"
               formControlName="lastName"
               class="input">
      </app-input-field>
      <app-input-field [control]="formGroup.controls.email"
                       class="field-container"
                       [label]="'createUser.email'|translate">
        <input name="email"
               formControlName="email"
               class="input">
      </app-input-field>
    </div>
    <div class="section" *ngIf="(userPage$|async)?.type !== Roles.ROLE_EXPERT &&
      ((userPage$|async)?.type === Roles.ROLE_BROKER || (userPage$|async)?.type === Roles.ROLE_INSURER || (userPage$|async)?.type === Roles.ROLE_UNDERWRITER) ">
      <span class="section-title">{{'memberPage.editPage.lineOfBusinessOfferingAndInterested' |translate}}</span>
      <app-input-field [control]="formGroup.controls.offeringLOBs" class="field-container"
                       [label]="'memberPage.lobsoffering'|translate">
        <mat-select formControlName="offeringLOBs"
                    multiple
                    class="input">
          <mat-option (click)="toggleAllOffering()">
            {{ (allLOBsSelectedOffering ? 'memberPage.deselectAll' : 'memberPage.selectAll') | translate }}
          </mat-option>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlLineOfBusinessOffering" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let opt of filteredOptionsLineOfBusinessOffering | async"
                      [value]="opt">{{'lineOfBusiness.clauses.' + opt + '.name' | translate}}</mat-option>
        </mat-select>
      </app-input-field>
      <app-input-field *ngIf="(userPage$|async)?.type !== Roles.ROLE_BROKER"
                       [control]="formGroup.controls.lookingForLOBs"
                       class="field-container"
                       [label]="'memberPage.lobsinterested'|translate">
        <mat-select formControlName="lookingForLOBs"
                    multiple
                    class="input">
          <mat-option (click)="toggleAllLooking()">
            {{ (allLOBsSelectedLooking ? 'memberPage.deselectAll' : 'memberPage.selectAll') | translate }}
          </mat-option>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlLineOfBusinessLooking" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let opt of filteredOptionsLineOfBusinessLooking | async"
                      [value]="opt">{{'lineOfBusiness.clauses.' + opt + '.name' | translate}}</mat-option>
        </mat-select>
      </app-input-field>
    </div>
    <div class="section" *ngIf="(userPage$|async)?.type === Roles.ROLE_EXPERT">
      <span class="section-title">{{'memberPage.editPage.offeringExpertServices' |translate}}</span>
      <app-input-field [control]="formGroup.controls.expertServices" class="field-container"
                       [label]= "'memberPage.expertise'|translate">
        <mat-select formControlName="expertServices"
                    multiple
                    class="input">
          <mat-option (click)="toggleAllExpertServices()">
            {{ (allExpertServicesSelected ? 'memberPage.deselectAll' : 'memberPage.selectAll') | translate }}
          </mat-option>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlExpertServices" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let opt of filteredOptionsExpertServices | async"
                      [value]="opt">{{'expertServices.clauses.' + opt + '.name' | translate}}</mat-option>
        </mat-select>
      </app-input-field>
    </div>
    <div class="section">
      <span class="section-title">{{'memberPage.editPage.aboutMe' |translate}}</span>
      <app-input-field [control]="formGroup.controls.introductionText" class="field-container"
                       [label]="'memberPage.editPage.aboutMeLabel'|translate">
      <textarea name="introductionText"
                cdkTextareaAutosize
                [placeholder]="'memberPage.editPage.aboutMePlaceholder'|translate"
                [cdkAutosizeMinRows]="3"
                formControlName="introductionText" class="input input-text-area"> </textarea>
      </app-input-field>
    </div>
    <div class="section">
      <span class="section-title">{{'memberPage.editPage.contactInformation' |translate}}</span>
      <app-input-field [control]="formGroup.controls.telephoneNumber" class="field-container"
                       [label]="'createUser.contactInformationForm.phoneNumber'|translate">
        <input name="telephoneNumber" formControlName="telephoneNumber" class="input">
      </app-input-field>
      <app-input-field [control]="formGroup.controls.mobileNumber" class="field-container"
                       [label]="'createUser.contactInformationForm.mobileNumber'|translate">
        <input name="mobileNumber" formControlName="mobileNumber" class="input">
      </app-input-field>

    </div>
  </div>
  <div class="buttons">
    <button (click)="emitClose()" class="blue-border">{{'cancel'|translate}}</button>
    <button (click)="submit()" class="blue-content" data-cy="save-button" >{{"save"|translate}}</button>
  </div>
</form>
